const React = require('react');
const T = require('prop-types');
const { default: TextField } = require('@mui/material/TextField');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { default: RaisedButton } = require('@mui/material/Button');
const { default: SwapHorizIcon } = require('@mui/icons-material/SwapHoriz');
const FullScreenDialog = require('containers/FullScreenDialog');

const internals = {};

module.exports = class ChangeRoleDialog extends React.Component {

    static propTypes = {
        user: T.shape({
            id: T.any.isRequired,
            firstName: T.string.isRequired,
            role: T.shape({
                id: T.any,
                label: T.string,
                name: T.string
            })
        }),
        schoolRoles: T.arrayOf(T.shape({
            id: T.any.isRequired,
            label: T.string,
            name: T.string
        })),
        open: T.bool.isRequired,
        onRequestClose: T.func.isRequired,
        onSubmit: T.func.isRequired
    }

    constructor() {

        super();

        this.state = {
            selectedRoleId: ''
        };

        this.reset = this._reset.bind(this);
        this.submit = this._submit.bind(this);
        this.updateSelectedRole = this._updateSelectedRole.bind(this);
    }

    _submit() {

        const { user: { id: userId }, onSubmit, onRequestClose } = this.props;
        const { selectedRoleId } = this.state;

        const currentRoleId = this.props.user.role && this.props.user.role.id;

        if (!selectedRoleId || selectedRoleId === currentRoleId) {
            return;
        }

        onSubmit({ userId, roleId: selectedRoleId });
        onRequestClose();
        this.reset();
    }

    _reset() {

        this.setState({ selectedRoleId: '' });
    }

    _updateSelectedRole(ev) {

        this.setState({ selectedRoleId: ev.target.value });
    }

    render() {

        const { styles } = internals;
        const { user, schoolRoles = [], open, onRequestClose } = this.props;
        const { selectedRoleId } = this.state;

        const currentRole = user.role || {};
        const currentRoleLabel = currentRole.label || currentRole.name || 'Unknown';
        const currentRoleId = currentRole.id;

        const canSubmit = !!selectedRoleId && selectedRoleId !== currentRoleId;

        return <FullScreenDialog
            title={<span style={styles.title}>Change {user.firstName}'s Role</span>}
            open={open}
            onRequestClose={onRequestClose}
        >
            <div>
                <p style={styles.currentRole}>
                    Current role: <strong>{currentRoleLabel}</strong>
                </p>
                <TextField
                    select
                    fullWidth
                    label='New role'
                    value={selectedRoleId}
                    onChange={this.updateSelectedRole}
                >
                    <MenuItem value=''>
                        <em>Select a role…</em>
                    </MenuItem>
                    {schoolRoles.map((role) => (
                        <MenuItem
                            key={role.id}
                            value={role.id}
                            disabled={role.id === currentRoleId}
                        >
                            {role.label || role.name}{role.id === currentRoleId ? ' (current)' : ''}
                        </MenuItem>
                    ))}
                </TextField>
                <div style={styles.submitButtonContainer}>
                    <RaisedButton
                        color={'primary'}
                        variant={'contained'}
                        disabled={!canSubmit}
                        startIcon={<SwapHorizIcon />}
                        onClick={this.submit}
                    >Change Role</RaisedButton>
                </div>
            </div>
        </FullScreenDialog>;
    }
};

internals.styles = {
    title: {
        display: 'inline-block',
        width: '100%',
        textAlign: 'center'
    },
    currentRole: {
        marginTop: '0.75rem',
        marginBottom: '1.25rem'
    },
    submitButtonContainer: {
        marginTop: '1.5em'
    }
};
